exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delivery[data-v-5a65429d] {\n  width: 100%;\n  margin: 20px auto;\n}\n.delivery[data-v-5a65429d] ul {\n  text-align: left;\n  list-style: none;\n  font-family: 'TTNorms Light', sans-serif;\n  width: 100%;\n  text-decoration: none;\n  font-size: 16px;\n}\n.delivery[data-v-5a65429d] li {\n  font-size: 14px;\n  padding-left: 7px;\n  padding-top: 10px;\n}\n.delivery[data-v-5a65429d] li::before {\n  content: \"\";\n  background-color: #11bb2e;\n  display: inline-block;\n  font-size: 35px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  margin-left: -14px;\n  margin-right: 5px;\n  margin-bottom: 2px;\n}\n", ""]);

// exports
